<template>
  <v-container fluid>
    <h1>{{ get("header-1") }}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="5" xl="5" lg="5" md="5" sm="5">
            <p>
              {{ get("p-1.1") }}
            </p>
          </v-col>
          <v-col cols="7" xl="7" lg="7" md="7" sm="7">
            <v-img :src="image" class="image"></v-img>
          </v-col>
        </v-row>
        <v-row :class="theme + '-alt-background-1'">
          <v-col cols="12">
            <h2>{{ get("header-2") }}</h2>
            <p>
              {{ get("p-2.1") }}
              {{ get("company") }}
              {{ get("p-2.2") }}
            </p>
            <ul>
              <li>
                <strong>{{ get("p-2.3") }}</strong>
                {{ get("p-2.4") }}
              </li>
              <li>
                <strong>{{ get("p-2.5") }}</strong>
                {{ get("p-2.6") }}
              </li>
              <li>
                <strong>{{ get("p-2.7") }}</strong> 
                {{ get("p-2.8") }}
              </li>
              <li>
                <strong>{{ get(p-2.9) }}</strong>
                {{ get("p-2.10") }}
              </li>
              <li>
                <strong>{{ get("p-2.11") }}</strong> 
                {{ get("p-2.12") }}
              </li>
              <li>
                <strong>{{ get("p-2.13") }}</strong
                >
                {{ get("p-2.14") }}
              </li>
              <li>
                <strong>{{ get("p-2.15") }}</strong> 
                {{ get("p-2.16") }}
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <p>
              {{ get("p-2.17") }}
            </p>
            <h2>{{ get("header-3") }}</h2>
            <p>
              {{ get("p-3.1") }}
              {{ get("company") }}
              {{ get("p-3.2") }}
               <phonenumber phone="(303) 778-8010"></phonenumber>
              {{ get("p-3.3") }}
              <linkto :text="contact" to="/contact"></linkto>
              {{ get("p-3.4") }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
        <guild></guild>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import router from '@/router'
import linkto from "@/components/controls/link-to";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "Gutter-Protection",

  components: {
    estimate,
    linkto,
    phonenumber
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {
    this.pageName = "gutters-protection";
  },

  data: () => ({
    image: require("@/assets/gutters-2.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    onAbout() {
      router.push("/about/home");
    },
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>

</style>
